import SubjectAreaResourceModel from '../../generated/types/model/resource/SubjectAreaResourceModel';

export default class SubjectAreaResourceViewModel extends SubjectAreaResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
